import { Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { Supplier } from '../supplier';
import { SupplierDto } from '../dto/supplier-dto';
import { mapBonusCondition } from './bonus-condition-mapper';

export const mapSupplier = (locales: Locale[], supplier: SupplierDto): Supplier => ({
    id: supplier.id,
    name: supplier.name,
    image: supplier.image,
    conditions: supplier.conditions.map(condition => mapBonusCondition(condition)),
    conditionsOfPurchase: supplier.conditionsOfPurchase,
    termsOfDelivery: supplier.termsOfDelivery,
    isChargingSupplier: supplier.isChargingSupplier,
    paymentTerm: getLocalizedString(locales, supplier.paymentTerm?.text),
    address: supplier.address,
});
